import type { PreloadedQuery } from 'react-relay';
// eslint-disable-next-line jira/import-whitelist
import { createRelayResource } from '@jira/platform__graphql-relay-utils/src/services/resources/index.tsx';
import QUERY, {
	type CustomerExperiencesListQuery,
} from '@jira/navigation-apps__sidebar-nav4-sidebars-content-customer-service/src/ui/customer-experiences-expandable-menu/__generated__/CustomerExperiencesListQuery.graphql';
import type {
	RouterDataContext,
	ResourceStoreContext,
	RouterContext,
	RouteResource,
} from '@atlassian/react-resource-router';

export const customerExperiencesNavigationResource: RouteResource<
	PreloadedQuery<CustomerExperiencesListQuery, Record<string, unknown>>
> = createRelayResource<CustomerExperiencesListQuery>({
	type: 'CUSTOMER_EXPERIENCES_NAVIGATION_RESOURCE',
	getQuery(
		_routerContext: RouterDataContext | RouterContext,
		{ tenantContext: { cloudId, activationId } }: ResourceStoreContext,
	) {
		return {
			parameters: QUERY,
			options: {
				fetchPolicy: 'store-and-network',
			},
			variables: {
				cloudId,
				workspaceAri: `ari:cloud:jira:${cloudId}:workspace/${activationId}`,
			},
		};
	},
});
